import {
  ConstrainedObject,
  ConstraintItemType,
  ConstraintModifier,
  ConstraintModifierCondition,
  ConstraintModifierConditionField,
  ConstraintModifierConditionType,
  ConstraintScope,
  ConstraintType,
  SelectedElement,
} from '@Models';
import { selectedElementByScope } from '@Selectors/builder/myArmyList/common/constraints/elements/selectable/selected-element-by-scope';

export const modifierIsActive = (
  modifier: ConstraintModifier,
  constrainedObjects: ConstrainedObject[],
  selectedElements: SelectedElement[],
  selectedElement: SelectedElement,
): boolean => {
  return modifier.conditions.some((condition) => {
    if (condition.field === ConstraintModifierConditionField.Selections) {
      const elements = selectedElementByScope(
        constrainedObjects,
        selectedElements,
        selectedElement,
        condition.scope,
      );

      const elementCount = elements
        .filter(
          (element) =>
            condition.childId === element.constrained.id &&
            condition.childType === element.constrained.type,
        )
        .map((element) => element.count)
        .reduce((acc, count) => acc + count, 0);

      return compareValue(condition, elementCount);
    } else if (condition.field === ConstraintModifierConditionField.Point) {
      if (
        condition.scope === ConstraintScope.Roster ||
        condition.scope === ConstraintScope.Force
      ) {
        const element = constrainedObjects.find(
          (element) => element.type === ConstraintItemType.Roster,
        );
        const constraint = element?.constraints.find(
          (constraint) =>
            constraint.scope === condition.scope &&
            constraint.type === ConstraintType.Max,
        );

        return compareValue(condition, constraint?.value || 0);
      } else if (condition.scope === ConstraintScope.Parent) {
        return compareValue(condition, selectedElement.points);
      }
    }

    return false;
  });
};

export const compareValue = (
  condition: ConstraintModifierCondition,
  elementCount: number,
): boolean => {
  switch (condition.type) {
    case ConstraintModifierConditionType.EqualTo:
      return elementCount === parseInt(condition.value);
    case ConstraintModifierConditionType.AtLeast:
      return elementCount >= parseInt(condition.value);
    case ConstraintModifierConditionType.AtMost:
      return elementCount <= parseInt(condition.value);
  }
  return false;
};
